import { MenuItem } from '@mui/material';
import { useTranslation } from 'next-i18next';
import { DividerComponentInterface } from '../../../../../interfaces/pagebuilder';
import { PageBuilderSettingsSection, PageBuilderSettingsTable } from '../PageBuilderSettingsTable';

interface DividerSettingsTableInterface {
  component: DividerComponentInterface;
  onChange: (c: DividerComponentInterface) => void;
}

const DividerSettingsTable = ({ component, onChange }: DividerSettingsTableInterface) => {
  const { t } = useTranslation(['pagebuilder']);

  const settingSections: PageBuilderSettingsSection[] = [
    {
      settings: [
        {
          path: 'type',
          type: 'select',
          label: t('pagebuilder:divider-component.divider-style'),
          defaultValue: component.type,
          selectItems: [
            {
              name: t('pagebuilder:divider-component.solid'),
              value: 'solid',
            },
            {
              name: t('pagebuilder:divider-component.dotted'),
              value: 'dotted',
            },
            {
              name: t('pagebuilder:divider-component.dashed'),
              value: 'dashed',
            },
            {
              name: t('pagebuilder:divider-component.double'),
              value: 'double',
            },
          ],
          customSelectOptionRender: ({ name, value, key }) => (
            <MenuItem key={key} value={value}>
              <div className="w-full  p-4">
                <hr style={{ borderTop: `1px ${value} ${component.color}`, width: '100%' }} />
              </div>
            </MenuItem>
          ),
        },
        {
          path: 'stroke',
          type: 'select',
          label: t('pagebuilder:divider-component.divider-stroke'),
          defaultValue: component.stroke,
          selectItems: [
            {
              key: '1',
              name: '1',
              value: 1,
            },
            {
              key: '5',
              name: '5',
              value: 5,
            },
            {
              key: '10',
              name: '10',
              value: 10,
            },
            {
              key: '15',
              name: '15',
              value: 15,
            },
            {
              key: '20',
              name: '20',
              value: 20,
            },
            {
              key: '25',
              name: '25',
              value: 25,
            },
            {
              key: '30',
              name: '30',
              value: 30,
            },
            {
              key: '35',
              name: '35',
              value: 35,
            },
          ],
          customSelectOptionRender: ({ name, value, key }) => (
            <MenuItem key={key} value={value}>
              <div className="w-full  p-4">
                <hr style={{ borderTop: `${value + 'px'} ${component.type} ${component.color}`, width: '100%' }} />
              </div>
            </MenuItem>
          ),
        },
        {
          path: 'color',
          type: 'color',
          label: t('pagebuilder:color'),
          defaultValue: component.color,
        },
      ],
    },
  ];

  return <PageBuilderSettingsTable sections={settingSections} onChange={onChange} component={component} showTitleAndDescription={false} />;
};
export default DividerSettingsTable;
